<template>
    <div v-if="sendType == 'TEXT' && bodyText" class="chat-text">{{bodyText}}</div>

    <div v-else-if="sendType == 'FILE' && file" style="width: 100%">
      <img v-if="RegExp(/image\/*/).test(file.fileContentType)" :src="file.fileUrl" class="rcs-radius-image" />
      <video v-if="RegExp(/video\/*/).test(file.fileContentType)" :src="file.fileUrl" class="media" controls="controls"></video>
      <video v-if="RegExp(/audio\/*/).test(file.fileContentType)" :src="file.fileUrl" class="media" controls="controls"></video>
      <a v-if="RegExp(/application\/*/).test(file.fileContentType)" class="file-con" :href="file.fileUrl">{{file.fileName}}</a>
    </div>

    <div v-else-if="sendType == 'LOCATION' && location" style="width:100%">
      <MapItem :uniqueKey="createTime + 'map'"
        :latitude="location.latitude"
        :longitude="location.longitude"
        :address="location.address"
      >
      </MapItem>
    </div>
    
    
    <!-- <map v-else-if="{{sendType == 'LOCATION' && location}}" style="height: 400px;width: 100%;"
      scale="18" enablezoom="false" enablescroll="false" @click="{{openMap}}"
      latitude="{{location.latitude}}"
      longitude="{{location.longitude}}"
      coordtype="gcj02"
      markers="{{[{
        latitude: location.latitude,
        longitude: location.longitude,
        coordtype: 'gcj02',
        iconPath: '../static/images/location.png'
      }]}}"
    ></map> -->

    <div v-else-if="sendType == 'REPLY' && reply" style="display: flex">
      <div class="chat-text" style="flex: 1;">{{reply.replyName}}</div>
      <!-- <div class="chat-text extraText" style="width: 35px;">{{reply.replySource}}</div> -->
    </div>
</template>
  
<script>
  import MapItem from '../components/MapItem'
  export default {
    name: 'MessageType',
    props: {
      dataSource: Object,
    },
    data() {
      const { sendType, bodyText, file, location, reply, createTime } = this.dataSource || {};
      return {
        sendType, bodyText, file, location, reply, createTime
      }
    },
    components: {
      MapItem
    },
    methods: {
      openMap(){
        if(this.location){
          geolocation.openLocation({
            ...this.location,
            success: function() {
              console.log(`open location success`)
            },
            fail: function(data, code) {
              console.log(`open location fail, code = ${code}`)
            },
            complete: function() {
              console.log(`open location complete`)
            }
          })
        }
      }
    }

  }
</script>

<style lang="less">
  @import './styles.less';
  .Card{
    /* width: 100%; */
    flex-direction: column;
  }
  .chat-text {
    text-align: left;
    font-size: 12px;
    color: #000000;
    display: inline-block;
  }
  .extraText{
    margin-top: 2px;
    width: 35px;
    margin-left: 20px;
    font-size: 11px;
    color: #aaa;
  }
  .swiper {
    flex-direction: column;
    height: 600px;
  }
  .media {
    width: 100%;
    min-height: 400px;
    border-radius: 10px;
    object-fit: cover;
  }
</style>


// WEBPACK FOOTER //
// src/chatRoom/messageType.vue